import { Controller } from "@hotwired/stimulus"
import { Country, State, City } from "country-state-city"

export default class FillAddressController extends Controller {
  static targets = ["country", "state", "city", 'postalCode']

  connect() {
    this.loadCountries()
  }

  loadCountries() {
    const countryTarget = this.countryTarget
    setTimeout(() => {
      Country.getAllCountries().forEach(country => {
        countryTarget.add(
          new Option(country.name, country.isoCode)
        )
      })
    }, 100)
  }

  countryChanged() {
    const countryCode = this.countryTarget.value

    this.stateTarget.innerHTML = '<option value="">Select State</option>'
    this.cityTarget.innerHTML = '<option value="">Select City</option>'

    State.getStatesOfCountry(countryCode).forEach(state => {
      this.stateTarget.add(
        new Option(state.name, state.isoCode)
      )
    })
    this.postalCodeChange(event)
  }

  stateChanged() {
    const countryCode = this.countryTarget.value
    const stateCode = this.stateTarget.value

    this.cityTarget.innerHTML = '<option value="">Select City</option>'

    City.getCitiesOfState(countryCode, stateCode).forEach(city => {
      this.cityTarget.add(
        new Option(city.name, city.name)
      )
    })
    this.postalCodeChange(event)
  }

  cityChanged() {
    this.postalCodeChange(event)
  }

  postalCodeChange(event) {
    const postalCode = this.postalCodeTarget.value.trim()

    if (!postalCode) return

    const geocoder = new google.maps.Geocoder()

    geocoder.geocode(
      {
        address: postalCode,
        componentRestrictions: {
          country: this.countryTarget.value
        }
      },
      (results, status) => {

        if (status !== "OK" || !results.length) {
          $('#user_address_pin_code-error')
            .text("Invalid postal code")
            .show()
          return
        }

        const components = results[0].address_components

        const getComponent = (type) =>
          components.find(c => c.types.includes(type))?.long_name

        const city = [getComponent("administrative_area_level_3"), getComponent("locality")]
        const state = getComponent("administrative_area_level_1")
        const country = getComponent("country")

        const cityMatches =
          !this.cityTarget.value || city.includes(this.cityTarget.value)

        const stateMatches =
          !this.stateTarget.value || state === this.stateTarget.selectedOptions[0].text

        const countryMatches =
          !this.countryTarget.value || country === this.countryTarget.selectedOptions[0].text

        if (!cityMatches || !stateMatches || !countryMatches) {
          this.postalCodeTarget.setAttribute("data-invalid", "true");
          $('#user_address_pin_code-error')
            .text("Postal code doesn't match the selected location.")
            .show()

          return
        }
        this.postalCodeTarget.setAttribute("data-invalid", "false");
        $('#user_address_pin_code-error').hide()
      }
    )
  }
}